import { useCallback } from 'react';
import { useSubscriptionConsentContext } from '../context/subscriptionConsent';
import { useUser } from 'store/features/auth/selectors/user';
import dataSources from 'dataSources';

export const useSendEmail = () => {
  const { email } = useSubscriptionConsentContext();
  const user = useUser();

  return useCallback(async () => {
    const dateNow = new Date().toISOString().substring(0, 10);
    const userCode = user?.clientCode || 'N/A';
    const emailMessage = `
      <style>
        table {
          border-collapse: collapse;
        }
        th,
        td {
        border: 1px solid black;
        padding: 5px;
        }
      </style>

      <h1>Subscription Activation Request</h1>
      <table>
        <thead>
          <th>Код клиента</th>
          <th>Дата активации</th>
          <th>E-mail</th>
        </thead>
        <tbody>
          <tr>
            <td>${userCode}</td>
            <td>${dateNow}</td>
            <td>${email}</td>
          </tr>
        </tbody>
      </table>
    `;

    await dataSources.application.sendEmail({
      destinationAddresses: ['locatorpro@e100.eu'],
      subject: `Subscription Activation Request from ${user?.clientCode || 'Unknown Client'}`,
      text: emailMessage,
    });
  }, [email, user?.clientCode]);
};
